module.exports = __webpack_public_path__ + "bb2.no2.64dfeb6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bb2.no2.jpg
// module id = sjXl
// module chunks = 0